var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 906,
    viewBox: "0 0 1440 906",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_1238)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 906,
    rx: 40,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_261_1238)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 41,
    width: 1440,
    height: 870.101,
    rx: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 41L251 41L251 925.69H0L0 41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_261_1238)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 219.876,
    height: 277,
    transform: "translate(15.0627 137.757)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_261_1238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 146.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "#EAEBEC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.0627,
    y: 146.757,
    width: 144.27,
    height: 24,
    rx: 6.5743,
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_261_1238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 193.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "#EEEDFF"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.0627,
    y: 193.757,
    width: 144.27,
    height: 24,
    rx: 6.5743,
    fill: "#EEEDFF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_261_1238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 240.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "#EAEBEC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.0627,
    y: 240.757,
    width: 144.27,
    height: 24,
    rx: 6.5743,
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_261_1238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 287.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "#EAEBEC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.0627,
    y: 287.757,
    width: 144.27,
    height: 24,
    rx: 6.5743,
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_261_1238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 334.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "#EAEBEC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.0627,
    y: 334.757,
    width: 144.27,
    height: 24,
    rx: 6.5743,
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_261_1238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 381.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "#EAEBEC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.0627,
    y: 381.757,
    width: 144.27,
    height: 24,
    rx: 6.5743,
    fill: "#EAEBEC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_261_1238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.601 95.6304L72.8568 74.467H78.6354L82.6109 86.2458L83.276 88.4478H83.3646L84.0297 86.2753L87.9313 74.467H93.5917L85.5815 95.6304H80.601ZM95.5023 102C95.5023 102 95.4974 102 95.4875 102C95.4875 102 95.4924 102 95.5023 102L99.3448 93.7239L99.3596 95.7043L92.8273 80.3638H98.2955L101.103 87.8715L101.562 89.438H101.665L102.153 87.8567L104.857 80.3638H110.163L101.089 102C101.099 102 101.099 102 101.089 102H95.5023ZM121.769 96.1477C120.744 96.1477 119.823 95.9457 119.005 95.5417C118.187 95.1279 117.503 94.5663 116.951 93.8569H115.68L116.862 92.6451V95.6304H111.749V74.467H117.099V81.8269H117.202C117.714 81.216 118.375 80.7332 119.182 80.3786C120 80.0239 120.882 79.8465 121.828 79.8465C123.887 79.8465 125.577 80.5805 126.897 82.0486C128.227 83.5166 128.892 85.4773 128.892 87.9306C128.892 90.3445 128.222 92.3199 126.882 93.8569C125.542 95.3841 123.838 96.1477 121.769 96.1477ZM120.335 91.714C121.301 91.714 122.099 91.3691 122.729 90.6795C123.36 89.9799 123.675 89.0833 123.675 87.9897C123.675 86.8961 123.355 86.0044 122.715 85.3147C122.084 84.625 121.291 84.2802 120.335 84.2802C119.389 84.2802 118.596 84.625 117.956 85.3147C117.315 85.9945 116.995 86.8862 116.995 87.9897C116.995 89.0833 117.31 89.9799 117.941 90.6795C118.581 91.3691 119.38 91.714 120.335 91.714ZM138.856 96.1477C136.373 96.1477 134.333 95.3792 132.737 93.8421C131.141 92.3051 130.343 90.3592 130.343 88.0045C130.343 85.6201 131.141 83.6644 132.737 82.1372C134.333 80.6101 136.373 79.8465 138.856 79.8465C141.348 79.8465 143.393 80.615 144.989 82.152C146.585 83.6792 147.383 85.63 147.383 88.0045C147.383 90.3592 146.585 92.3051 144.989 93.8421C143.403 95.3792 141.358 96.1477 138.856 96.1477ZM138.871 91.6844C139.826 91.6844 140.619 91.3396 141.25 90.6499C141.89 89.9504 142.211 89.0686 142.211 88.0045C142.211 86.9207 141.89 86.034 141.25 85.3443C140.61 84.6546 139.816 84.3097 138.871 84.3097C137.905 84.3097 137.102 84.6546 136.462 85.3443C135.821 86.034 135.501 86.9207 135.501 88.0045C135.501 89.0686 135.821 89.9504 136.462 90.6499C137.102 91.3396 137.905 91.6844 138.871 91.6844ZM157.077 102.458C155.875 102.458 154.821 102.325 153.915 102.059C153.008 101.793 152.2 101.404 151.491 100.892C150.792 100.379 150.235 99.8178 149.821 99.2069C149.417 98.596 149.215 98.2906 149.215 98.2906L153.191 96.2954C153.191 96.2954 153.304 96.4679 153.531 96.8127C153.767 97.1674 154.053 97.4778 154.388 97.7438C154.723 98.0197 155.102 98.2266 155.526 98.3645C155.959 98.5024 156.432 98.5714 156.944 98.5714C158.146 98.5714 159.058 98.2463 159.679 97.596C160.309 96.9457 160.624 96.059 160.624 94.9358V93.5466H160.521C159.969 94.2067 159.289 94.7141 158.481 95.0688C157.683 95.4235 156.792 95.6008 155.806 95.6008C153.757 95.6008 152.082 94.8964 150.782 93.4875C149.491 92.0785 148.846 90.1819 148.846 87.7976C148.846 85.4329 149.525 83.5166 150.885 82.0486C152.255 80.5805 153.989 79.8465 156.087 79.8465C157.033 79.8465 157.9 80.0288 158.688 80.3933C159.477 80.7579 160.122 81.2702 160.624 81.9303H161.895L160.713 83.157V80.3638H165.827V94.5072C165.827 97.1083 165.048 99.0837 163.492 100.434C161.935 101.783 159.797 102.458 157.077 102.458ZM157.343 91.315C158.309 91.315 159.097 90.9849 159.708 90.3248C160.329 89.6548 160.639 88.7828 160.639 87.7089C160.639 86.6448 160.329 85.7876 159.708 85.1374C159.097 84.4772 158.309 84.1472 157.343 84.1472C156.388 84.1472 155.595 84.4772 154.964 85.1374C154.343 85.7876 154.033 86.6497 154.033 87.7237C154.033 88.8173 154.343 89.6893 154.964 90.3395C155.585 90.9898 156.378 91.315 157.343 91.315Z",
    fill: "#313537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.513 78.2788V74.5078H182.351V78.2788H166.513ZM172.438 96.1077V76.4816H176.451V96.1077H172.438Z",
    fill: "url(#paint0_linear_261_1238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.433 96.1078L188.699 74.5079H192.53L200.766 96.1078H196.344L191.44 82.0799L190.612 79.395H190.522L189.694 82.0627L184.747 96.1035H180.433V96.1078ZM184.264 91.3241L185.393 88.2168H195.271L196.447 91.3241H184.26H184.264Z",
    fill: "url(#paint1_linear_261_1238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.727 96.1078V74.5079H206.739V92.3368H216V96.1078H202.727Z",
    fill: "url(#paint2_linear_261_1238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3539 83.8071C41.8184 83.8071 43.0057 82.6199 43.0057 81.1554C43.0057 79.6909 41.8184 78.5036 40.3539 78.5036C38.8894 78.5036 37.7021 79.6909 37.7021 81.1554C37.7021 82.6199 38.8894 83.8071 40.3539 83.8071Z",
    fill: "#6860EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6159 68.6398H58.3462C58.3462 68.6398 54.5079 68.3273 52.5739 71.3296C51.6576 72.7526 47.0888 79.6564 43.8037 84.6095C43.4659 85.1204 43.5504 85.7918 43.9937 86.214C45.0662 87.2274 45.7165 88.6758 45.6616 90.2804C45.5645 93.0292 43.3434 95.2714 40.5946 95.4023C37.5417 95.5416 35.0208 93.1095 35.0208 90.0861C35.0208 88.566 35.6584 87.1937 36.6803 86.2267C37.1152 85.8171 37.1785 85.15 36.8449 84.6559L34.7548 81.5819C34.0496 80.3911 32.9518 79.4706 31.6428 79.0357C31.0812 78.8499 30.4351 78.7275 29.7131 78.7275H23.5862C23.5862 78.7275 21.9351 78.5797 22.9697 80.294L32.7786 95.681C33.9778 97.484 35.8062 100.292 38.4791 101.335C39.6994 101.812 41.3462 101.656 42.5707 101.09C44.8636 100.03 46.1514 98.1723 47.1015 96.7662L64.376 69.9361C64.376 69.9361 65.0727 68.6398 63.6159 68.6398Z",
    fill: "#6860EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.857 91.564C30.7477 91.9441 28.2522 88.5365 28.2522 88.5365C28.2522 88.5365 32.6732 95.4783 33.505 96.7282C34.3369 97.9781 36.4059 100.52 38.4792 101.331C39.6995 101.808 41.511 101.571 42.7355 101.006C45.0284 99.9458 46.4683 97.805 47.1059 96.7662L55.475 83.7523C55.475 83.7523 53.2243 83.499 45.8349 87.9242C39.9867 91.4289 38.6777 91.3614 35.8612 91.5683L35.857 91.564Z",
    fill: "#9691F3"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15.5625,
    y: 831.69,
    width: 219.876,
    height: 55,
    rx: 16,
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5625 859.19C28.5625 850.077 35.9498 842.69 45.0625 842.69V842.69C54.1752 842.69 61.5625 850.077 61.5625 859.19V859.19C61.5625 868.303 54.1752 875.69 45.0625 875.69V875.69C35.9498 875.69 28.5625 868.303 28.5625 859.19V859.19Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1482 865.19L75.7228 853.469H77.9035L80.4689 860.219C80.7254 860.925 80.9499 861.614 81.2064 862.56C81.495 861.534 81.7356 860.813 81.96 860.219L84.4934 853.469H86.6259L82.2647 865.19H80.1482ZM88.7776 855.682C88.1042 855.682 87.575 855.153 87.575 854.495C87.575 853.838 88.1042 853.325 88.7776 853.325C89.4189 853.325 89.9481 853.838 89.9481 854.495C89.9481 855.153 89.4189 855.682 88.7776 855.682ZM87.7995 865.19V857.269H89.7556V865.19H87.7995ZM91.1674 862.785H93.0273C93.0434 863.474 93.5564 863.907 94.4543 863.907C95.3683 863.907 95.8653 863.538 95.8653 862.961C95.8653 862.56 95.6569 862.272 94.9514 862.111L93.5244 861.775C92.0974 861.454 91.4079 860.781 91.4079 859.514C91.4079 857.959 92.7227 857.029 94.5505 857.029C96.3303 857.029 97.5329 858.055 97.5489 859.594H95.689C95.6729 858.921 95.224 858.488 94.4704 858.488C93.7007 858.488 93.2518 858.841 93.2518 859.434C93.2518 859.883 93.6045 860.171 94.278 860.332L95.705 860.668C97.0358 860.973 97.7092 861.582 97.7092 862.801C97.7092 864.404 96.3463 865.398 94.3902 865.398C92.418 865.398 91.1674 864.34 91.1674 862.785ZM101.155 865.19H99.1986V853.261H101.171V858.295C101.668 857.526 102.598 857.029 103.736 857.029C105.692 857.029 106.719 858.263 106.719 860.316V865.19H104.762V860.781C104.762 859.45 104.105 858.808 103.111 858.808C101.876 858.808 101.155 859.674 101.155 860.861V865.19ZM115.303 865.19H113.251V853.469H117.724C120.386 853.469 121.941 854.816 121.941 857.125C121.941 858.696 121.204 859.819 119.825 860.38L122.053 865.19H119.809L117.82 860.813H115.303V865.19ZM115.303 855.297V859.001H117.724C119.023 859.001 119.793 858.311 119.793 857.125C119.793 855.954 119.023 855.297 117.724 855.297H115.303ZM125.747 865.398C124.064 865.398 123.038 864.42 123.038 862.929C123.038 861.47 124.096 860.556 125.972 860.412L128.345 860.235V860.059C128.345 858.985 127.704 858.552 126.709 858.552C125.555 858.552 124.914 859.033 124.914 859.867H123.246C123.246 858.151 124.657 857.029 126.806 857.029C128.938 857.029 130.253 858.183 130.253 860.38V865.19H128.537L128.393 864.019C128.056 864.837 126.982 865.398 125.747 865.398ZM126.389 863.923C127.591 863.923 128.361 863.202 128.361 861.983V861.566L126.709 861.695C125.491 861.807 125.026 862.208 125.026 862.849C125.026 863.571 125.507 863.923 126.389 863.923ZM134.131 865.19H132.175V857.269H133.97L134.131 858.199C134.532 857.542 135.333 857.029 136.472 857.029C137.674 857.029 138.508 857.622 138.925 858.536C139.326 857.622 140.256 857.029 141.458 857.029C143.382 857.029 144.441 858.183 144.441 860.011V865.19H142.5V860.524C142.5 859.386 141.891 858.792 140.961 858.792C140.015 858.792 139.294 859.402 139.294 860.7V865.19H137.338V860.508C137.338 859.402 136.744 858.808 135.814 858.808C134.884 858.808 134.131 859.418 134.131 860.7V865.19ZM149.904 865.398C147.547 865.398 145.896 863.683 145.896 861.23C145.896 858.744 147.515 857.029 149.84 857.029C152.213 857.029 153.72 858.616 153.72 861.085V861.679L147.756 861.695C147.9 863.089 148.638 863.795 149.936 863.795C151.011 863.795 151.716 863.378 151.941 862.625H153.753C153.416 864.356 151.973 865.398 149.904 865.398ZM149.856 858.632C148.702 858.632 147.996 859.257 147.804 860.444H151.78C151.78 859.354 151.027 858.632 149.856 858.632ZM154.677 862.785H156.537C156.553 863.474 157.066 863.907 157.964 863.907C158.878 863.907 159.375 863.538 159.375 862.961C159.375 862.56 159.166 862.272 158.461 862.111L157.034 861.775C155.607 861.454 154.917 860.781 154.917 859.514C154.917 857.959 156.232 857.029 158.06 857.029C159.84 857.029 161.042 858.055 161.058 859.594H159.198C159.182 858.921 158.733 858.488 157.98 858.488C157.21 858.488 156.761 858.841 156.761 859.434C156.761 859.883 157.114 860.171 157.787 860.332L159.214 860.668C160.545 860.973 161.219 861.582 161.219 862.801C161.219 864.404 159.856 865.398 157.9 865.398C155.927 865.398 154.677 864.34 154.677 862.785ZM164.664 865.19H162.708V853.261H164.68V858.295C165.177 857.526 166.107 857.029 167.246 857.029C169.202 857.029 170.228 858.263 170.228 860.316V865.19H168.272V860.781C168.272 859.45 167.614 858.808 166.62 858.808C165.386 858.808 164.664 859.674 164.664 860.861V865.19Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.8022,
    y: 848.977,
    width: 114.456,
    height: 21.5456,
    rx: 6,
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1139,
    height: 65.1013,
    transform: "translate(277 41)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277,
    y: 57,
    width: 190,
    height: 33.1013,
    rx: 9.63413,
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1159.5,
    y: 57.0507,
    width: 111.1,
    height: 33,
    rx: 8.8,
    fill: "#6860EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.6,
    y: 57.0507,
    width: 125.4,
    height: 33,
    rx: 8.8,
    fill: "#6860EE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_261_1238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 124.101,
    width: 1137,
    height: 134,
    rx: 16,
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278 140.101C278 131.265 285.163 124.101 294 124.101H1399C1407.84 124.101 1415 131.265 1415 140.101V171.101H278V140.101Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_261_1238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 187.101,
    width: 1105,
    height: 47,
    rx: 16,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.5,
    y: 187.601,
    width: 1104,
    height: 46,
    rx: 15.5,
    stroke: "#F4F4F4",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_261_1238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1334 187.269H1387C1393.63 187.269 1399 192.642 1399 199.269V221.936C1399 228.563 1393.63 233.936 1387 233.936H1334V187.269Z",
    fill: "#6860EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1277.77,
    y: 181.657,
    width: 21.0131,
    height: 93.6704,
    rx: 10.5066,
    transform: "rotate(-22.3353 1277.77 181.657)",
    fill: "white",
    fillOpacity: 0.6
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 277,
    y: 284.076,
    width: 138.051,
    height: 24.0509,
    rx: 7,
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1181,
    y: 276.101,
    width: 183,
    height: 40,
    rx: 20,
    fill: "#F3F5F6",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_261_1238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1185,
    y: 280.101,
    width: 82,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1376,
    y: 276.101,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.5,
    y: 334.101,
    width: 366,
    height: 171,
    rx: 16,
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.5 541.101C277.5 532.265 284.663 525.101 293.5 525.101H627.5C636.337 525.101 643.5 532.265 643.5 541.101V680.101C643.5 688.938 636.337 696.101 627.5 696.101H293.5C284.663 696.101 277.5 688.938 277.5 680.101V541.101Z",
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.5 350.101C663.5 341.265 670.663 334.101 679.5 334.101H1013.5C1022.34 334.101 1029.5 341.265 1029.5 350.101V489.101C1029.5 497.938 1022.34 505.101 1013.5 505.101H679.5C670.663 505.101 663.5 497.938 663.5 489.101V350.101Z",
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1049.5,
    y: 334.101,
    width: 366,
    height: 171,
    rx: 16,
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.5 541.101C663.5 532.265 670.663 525.101 679.5 525.101H1013.5C1022.34 525.101 1029.5 532.265 1029.5 541.101V680.101C1029.5 688.938 1022.34 696.101 1013.5 696.101H679.5C670.663 696.101 663.5 688.938 663.5 680.101V541.101Z",
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1049.5,
    y: 525.101,
    width: 366,
    height: 171,
    rx: 16,
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.5,
    y: 716.101,
    width: 366,
    height: 171,
    rx: 16,
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 663.5,
    y: 716.101,
    width: 366,
    height: 171,
    rx: 16,
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1049.5,
    y: 716.101,
    width: 366,
    height: 171,
    rx: 16,
    fill: "#EAEBEC"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 27.4363,
    cy: 21.3267,
    r: 8,
    fill: "#EC6765"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.4363,
    cy: 21.3267,
    r: 8,
    fill: "#F2C846"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.4363,
    cy: 21.3267,
    r: 8,
    fill: "#65C266"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_261_1238",
    x: 283,
    y: 176.101,
    width: 1127,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_261_1238"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.440509 0 0 0 0 0.440509 0 0 0 0 0.440509 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_261_1238"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_261_1238",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_261_1238",
    x: 1183,
    y: 279.101,
    width: 86,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_261_1238"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_261_1238",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_261_1238",
    x1: 174.942,
    y1: 76.3825,
    x2: 174.942,
    y2: 101.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6860EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9691F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_261_1238",
    x1: 191.254,
    y1: 76.3826,
    x2: 191.254,
    y2: 101.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6860EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9691F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_261_1238",
    x1: 209.791,
    y1: 76.3826,
    x2: 209.791,
    y2: 101.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6860EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9691F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_1238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 906,
    rx: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_261_1238"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 41,
    width: 1440,
    height: 870.101,
    rx: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_261_1238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 219.876,
    height: 733.121,
    fill: "white",
    transform: "translate(15.061 133.163)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_261_1238"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 146.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_261_1238"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 193.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_261_1238"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 240.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_261_1238"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 287.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_261_1238"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 334.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_261_1238"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 381.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_261_1238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 189.373,
    height: 36.2421,
    fill: "white",
    transform: "translate(22.6277 68.8496)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_261_1238"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 124.101,
    width: 1137,
    height: 134,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_261_1238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1334 187.269H1387C1393.63 187.269 1399 192.642 1399 199.269V221.936C1399 228.563 1393.63 233.936 1387 233.936H1334V187.269Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMode);
export default __webpack_public_path__ + "static/media/Light-Mode.07a6d7fea3055bf0fc46eb9afd859067.svg";
export { ForwardRef as ReactComponent };